import React from 'react';
import { LayersIcon, ActivityIcon, GitBranchIcon, BookOpenIcon, GiftIcon, ClipboardCheckIcon } from 'lucide-react';
const POINTS = [{
  icon: LayersIcon,
  title: 'Des fiches techniques prêtes à consulter',
  body: 'Fiches de diagnostic, schémas de composants et tableaux de contrôle : ouvrez le système sur la tablette de l’atelier ou imprimez-le, au lieu de chercher dans plusieurs sources.'
}, {
  icon: ActivityIcon,
  title: 'Une méthode pour chaque panne',
  body: 'SYMPTÔME › CODES › MESURES › HYPOTHÈSE › VALIDATION : toujours le même ordre, pour ne sauter aucune étape.'
}, {
  icon: GitBranchIcon,
  title: 'Des arbres de décision',
  body: 'Code présent ou absent, bruit, vibration ou à-coup : chaque situation fréquente a son chemin de contrôle, du plus simple au plus lourd.'
}, {
  icon: ClipboardCheckIcon,
  title: 'Des procédures et checklists d’atelier',
  body: 'Réception du véhicule, contrôle d’un capteur ou d’un actionneur, vérification après réparation, encadrés sécurité : prêts à l’emploi.'
}, {
  icon: BookOpenIcon,
  title: '6 modules complémentaires',
  body: 'Électronique et OBD-II, moteur et injection, électricité, transmission, freinage et direction, méthodes et fiches atelier.'
}, {
  icon: GiftIcon,
  title: '5 bonus pratiques',
  body: 'Codes défaut OBD-II, guide du multimètre, fiches atelier imprimables, voyants du tableau de bord, cahier de 50 cas pratiques.'
}];
export function NotEbook() {
  return <section className="bg-navy py-5 sm:py-7" data-id="element-115" data-mp="2sruty49tin2v">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-116" data-mp="2sp0aog2jj8b1">
        <h2 className="text-center text-2xl leading-tight text-white sm:text-4xl" data-id="element-117" data-mp="2nqf6k5k644hb">
          CE N’EST PAS UN SIMPLE EBOOK DE PLUS SUR LA MÉCANIQUE
        </h2>
        <p className="mt-1 text-center font-display text-sm font-bold uppercase leading-tight text-tech-light sm:text-xl" data-id="element-118" data-mp="1ccbg39csgyh0">
          C’EST UN SYSTÈME PROFESSIONNEL COMPLET POUR DIAGNOSTIQUER ET TRAVAILLER AVEC MÉTHODE.
        </p>

        <div className="mt-3 grid gap-2 sm:grid-cols-2 sm:gap-2.5" data-id="element-119" data-mp="19t6od9gxg0jr">
          {POINTS.map(point => {
          const Icon = point.icon;
          return <div key={point.title} className="flex gap-3 rounded-xl border border-white/15 bg-navy-deep p-3" data-id="element-120" data-mp="zu7n4byhr76s">
                <Icon className="mt-0.5 h-5 w-5 shrink-0 text-tech-light" aria-hidden="true" data-id="element-121" data-mp="14r7jtw9gaxl8" />
                <div data-id="element-122" data-mp="r0chz3xddgr5">
                  <h3 className="text-sm leading-tight text-white sm:text-base" data-id="element-123" data-mp="qzsxbfgc4e9f">{point.title}</h3>
                  <p className="mt-0.5 text-sm leading-snug text-white/80" data-id="element-124" data-mp="vu6zq1tezlnl">{point.body}</p>
                </div>
              </div>;
        })}
        </div>

        <p className="mt-3 text-center font-display text-sm font-extrabold uppercase text-white sm:text-lg" data-id="element-125" data-mp="m32iswk6hqq4">
          Moins de pièces changées au hasard. <span className="text-tech-light" data-id="element-126" data-mp="c44yy6xp6ldg">Plus de méthode, panne après panne.</span>
        </p>
      </div>
    </section>;
}